// @ts-nocheck
import { h } from "preact";
import { Input, Modal } from "antd";
import { useEffect, useState, useImperativeHandle } from "preact/hooks";
import { forwardRef } from "react";
import { Text } from "../../../../components/text";
import { useMessage } from "../../../../hooks/useMessage";

// controlled <Modal> แทน Modal.confirm (imperative) — เลี่ยง Preact __h error ตอน unmount
export const ModalDeleteRepair = forwardRef<any, any>((props, ref) => {
  const { onCallbackDelete } = props;
  const { openMessage } = useMessage();
  const [visible, setVisible] = useState(false);
  const [record, setRecord] = useState<any>(null);
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    !visible && setRemark("");
  }, [visible]);

  useImperativeHandle(ref, () => ({
    openModal(e: any) {
      setRecord(e);
      setRemark("");
      setVisible(true);
    },
  }));

  const onConfirm = async () => {
    if (!remark.trim()) {
      return openMessage("error", "กรุณาระบุเหตุผลการลบ");
    }
    try {
      setLoading(true);
      await onCallbackDelete(record, remark.trim());
      setVisible(false);
    } catch (error) {
      openMessage("error", (error as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      centered
      width={520}
      title={
        (<Text size={"L"} text={"ยืนยันการลบรายการ"} bold />) as React.ReactNode
      }
      transitionName={""}
      visible={visible}
      okText={"ลบ"}
      cancelText={"ยกเลิก"}
      okButtonProps={{ danger: true } as any}
      confirmLoading={loading}
      onOk={onConfirm}
      onCancel={() => setVisible(false)}
    >
      <Input.TextArea
        placeholder="เหตุผลการลบ"
        rows={3}
        value={remark}
        onChange={(e: any) => setRemark(e.target.value)}
      />
    </Modal>
  );
});
